enum StreamType {
  DASH,
  HLS,
}

export default StreamType;
